import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Field } from "./common";

const OPTIONS = ["Lean Six Sigma Yellow Belt", "Lean Six Sigma Green Belt", "Certified Six Sigma Black Belt", "Mixed / not sure yet"];
const MODES = ["On-site at our company", "Classroom (Dexterity venue)", "Live virtual sessions"];

export default function TrainingRequestForm({ user, onSent, dark = false }) {
  const blank = { contact_name: user?.name || "", company_name: user?.company_name || "", email: user?.email || "", phone: user?.phone || "", training: OPTIONS[0], staff_count: 5, mode: MODES[0], preferred_date: "", message: "" };
  const [f, setF] = useState(blank);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const cls = `dx-input ${dark ? "bg-white/5 border-white/20 text-white placeholder:text-white/40" : ""}`;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/training-requests", { ...f, staff_count: Number(f.staff_count) || 1 });
      toast.success("Request sent - our team will contact you shortly");
      setF(blank);
      onSent?.();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className={`grid sm:grid-cols-2 gap-4 ${dark ? "[&_.dx-label]:text-white/60" : ""}`} data-testid="training-request-form">
      <Field label="Contact name"><input required className={cls} value={f.contact_name} onChange={set("contact_name")} data-testid="treq-name-input" /></Field>
      <Field label="Company"><input required className={cls} value={f.company_name} onChange={set("company_name")} data-testid="treq-company-input" /></Field>
      <Field label="Email"><input required type="email" className={cls} value={f.email} onChange={set("email")} data-testid="treq-email-input" /></Field>
      <Field label="Phone"><input required className={cls} value={f.phone} onChange={set("phone")} data-testid="treq-phone-input" /></Field>
      <Field label="Training needed">
        <select className={cls} value={f.training} onChange={set("training")} data-testid="treq-training-select">{OPTIONS.map((o) => <option key={o} className="text-black">{o}</option>)}</select>
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="No. of staff"><input type="number" min="1" className={cls} value={f.staff_count} onChange={set("staff_count")} data-testid="treq-count-input" /></Field>
        <Field label="Preferred date"><input type="date" className={cls} value={f.preferred_date} onChange={set("preferred_date")} data-testid="treq-date-input" /></Field>
      </div>
      <div className="sm:col-span-2"><Field label="Delivery">
        <select className={cls} value={f.mode} onChange={set("mode")} data-testid="treq-mode-select">{MODES.map((o) => <option key={o} className="text-black">{o}</option>)}</select>
      </Field></div>
      <div className="sm:col-span-2"><Field label="Anything else?"><textarea rows={3} className={cls} value={f.message} onChange={set("message")} data-testid="treq-message-input" /></Field></div>
      <button className="dx-btn-gold sm:col-span-2 py-3" disabled={busy} data-testid="treq-submit-btn"><Send className="w-4 h-4" />{busy ? "Sending…" : "Request staff training"}</button>
    </form>
  );
}
